import axios from "axios";

const EM_ADMIN = process.env.VUE_APP_EM_ADMIN_URL;
const SITH_MES = process.env.VUE_APP_SITHMES_MST_URL;

function authHeaders(extra = {}) {
    const headers = { ...extra };
    const jwt = localStorage["em_sso_token"];
    if (jwt != null) {
        headers["Authorization"] = jwt;
    }
    return headers;
}

export function dataURLtoBlob(dataURL) {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8 = new Uint8Array(n);
    while (n--) {
        u8[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8], { type: mime });
}

export function uploadEncryptedImage(pngBlob) {
    const form = new FormData();
    form.append("file", pngBlob, "signature.png");
    return axios
        .post(EM_ADMIN + "/emAttachment/upload/encrypt", form, {
            headers: authHeaders({ "Content-Type": "multipart/form-data" })
        })
        .then(res => res.data && res.data.data ? res.data.data : res.data);
}

export function prepareSignature() {
    return axios
        .post(SITH_MES + "/signature/prepare", {}, {
            headers: authHeaders({ "Content-Type": "application/json" })
        })
        .then(res => res.data && res.data.data ? res.data.data : res.data);
}

export function saveSignature(payload) {
    return axios
        .post(SITH_MES + "/signature/save", payload, {
            headers: authHeaders({ "Content-Type": "application/json" })
        })
        .then(res => res.data && res.data.data ? res.data.data : res.data);
}

export function getSignature(uuid) {
    return axios
        .get(SITH_MES + "/signature/get?uuid=" + encodeURIComponent(uuid), {
            headers: authHeaders()
        })
        .then(res => res.data && res.data.data ? res.data.data : res.data);
}
